import React from 'react';
import './index.less'

type CustomSearchItem = {
  labelTitle: string
  children: any
  customStyle?: any
}

const CustomSearchItem = (props: CustomSearchItem) => {
  return (
    <div className={'customSearchItem'} style={props?.customStyle}>
        <div style={{ whiteSpace: 'nowrap' }} className="select-label">
          {props?.labelTitle}
        </div>
        <div className="select-input">
        {props?.children}
      </div>
    </div>
  )
}

export default CustomSearchItem
